import camelCase from 'lodash/camelCase';

export const getEntityTranslationKey = (entityParam: string): TranslationId => {
  const camelCased = camelCase(entityParam);
  return (camelCased.charAt(0).toUpperCase() + camelCased.slice(1)) as TranslationId;
};
